function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M 5.868 3.421 L 11.831 3.421 L 11.831 13.501 L 5.868 13.501 L 5.868 3.421 Z",
  style: {
    stroke: "rgb(0, 0, 0)",
    fill: "rgb(255, 255, 255)",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M 9 18 C 13.971 18 18 13.971 18 9 C 18 4.029 13.971 0 9 0 C 4.029 0 0 4.029 0 9 C 0 13.971 4.029 18 9 18 Z M 8.402 8.793 L 8.006 5.207 C 7.933 4.577 8.582 4 9.195 4 C 9.807 4 10.474 4.577 10.402 5.207 L 10.006 8.793 C 9.951 9.243 9.645 9.604 9.195 9.604 C 8.762 9.604 8.456 9.243 8.402 8.793 Z M 9.195 10.793 C 9.861 10.793 10.402 11.333 10.402 12 C 10.402 12.667 9.861 13.207 9.195 13.207 C 8.546 13.207 8.006 12.667 8.006 12 C 8.006 11.333 8.546 10.793 9.195 10.793 Z",
  style: {
    fill: "currentColor"
  }
})));
export default SvgWarningAlert;